import { render, staticRenderFns } from "./ConceptChangeDiffDialog.vue?vue&type=template&id=1af068a6&scoped=true"
import script from "./ConceptChangeDiffDialog.vue?vue&type=script&lang=js"
export * from "./ConceptChangeDiffDialog.vue?vue&type=script&lang=js"
import style0 from "./ConceptChangeDiffDialog.vue?vue&type=style&index=0&id=1af068a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../photo-retention-20261014/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af068a6",
  null
  
)

export default component.exports